"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailureChain = void 0;
class FailureChain {
    static { this.MAX_DEPTH = 32; }
    static innermost(error) {
        if (!(error instanceof Error)) {
            return { message: String(error) };
        }
        let message = error.message;
        let type;
        let current = error;
        const seen = new Set();
        for (let depth = 0; depth < FailureChain.MAX_DEPTH && current instanceof Error && !seen.has(current); depth++) {
            seen.add(current);
            if (current.message.length > 0) {
                message = current.message;
            }
            if ('type' in current && typeof current.type === 'string' && current.type.length > 0) {
                type = current.type;
            }
            current = current.cause;
        }
        return type === undefined ? { message } : { type, message };
    }
}
exports.FailureChain = FailureChain;
//# sourceMappingURL=failure-chain.js.map